var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestRegistered(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#83ffc1;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#FFFFFF;stroke:#11bd4f;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 75,
    cy: 75,
    r: 71
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67,83l6-1c-1.9-3.81-2.52-6.78-2-9h-4V83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59,71l-0.07,33.36l4.17,0.81c3.13,0.61,6.32,0.88,9.51,0.73c6.95-0.31,13.52-1.52,19.62-3.88 c2.64-1.41,5.16-1.96,7.61-1.95c2.14-0.04,3.65-0.61,4.02-2.13V76.27c-0.56-1.8-1.87-2.47-3.41-2.8h0c-3.25-0.2-6.36-1.38-8.92-3.4 l-4.65-3.66c-2.11-1.67-3.7-3.9-4.58-6.45v0c-1.69-4.92-2.55-10.08-2.55-15.28v0c-4.32-2.21-7.06,1.64-8.96,8.7 c-0.35,2.53,0.11,4.81,1.08,6.94l0.02,10.88l-9.22,0.11L59,71l12.86,0.33c-0.51,7.16,2.12,12.28,7.89,15.34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.02,79.71h14.7c2.32,0,4.19-1.88,4.19-4.19s-1.88-4.19-4.19-4.19h-14.7c-2.32,0-4.19,1.88-4.19,4.19 S49.71,79.71,52.02,79.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.62,80.15H49.93c-2.09,0-3.78,1.69-3.78,3.78v0c0,2.09,1.69,3.78,3.78,3.78h18.69 c2.09,0,3.78-1.69,3.78-3.78v0C72.4,81.84,70.71,80.15,68.62,80.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.14,88.13H52.57c-2.06,0-3.72,1.67-3.72,3.72v0.93c0,2.06,1.67,3.72,3.72,3.72h15.57 c2.06,0,3.72-1.67,3.73-3.72v-0.93C71.86,89.8,70.19,88.13,68.14,88.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.39,96.81H55.24c-1.81,0-3.27,1.47-3.27,3.27v1.01c0,1.81,1.47,3.27,3.27,3.27h13.15 c1.81,0,3.27-1.47,3.27-3.27v-1.01C71.67,98.27,70.2,96.81,68.39,96.81z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestRegistered);
export default __webpack_public_path__ + "static/media/requestRegistered.bd983d8f68ee10d994b5274e796d0077.svg";
export { ForwardRef as ReactComponent };